export default "__VITE_ASSET__CNTi6_Wz__"